import { find } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Actions from '../../../../../actions'
import EditMedicationForm from '../../../../../components/forms/screens/EditMedicationForm'
import Selectors from '../../../../../selectors'
import { history } from '../../../../../store'
import { withRouter } from '../../../../../withRouter'

export function DetailsScreen(props) {
  const {
    resident,
    medication,
    router: { params },
    openDiscontinueMedModal,
    testId
  } = props

  const editUrl = `/residents/${resident.id}/emar/${params.medication_id}/edit`

  return (
    <div
      style={styles.wrapper}
      data-testid={
        testId
          ? `${testId}-resident-med-details-screen`
          : 'resident-med-details-screen'
      }
    >
      <EditMedicationForm
        readOnly
        medication={medication}
        resident={resident}
        onConfirm={() => history.push(editUrl)}
        onDelete={() => openDiscontinueMedModal(medication, resident)}
        testId={testId}
      />
    </div>
  )
}

DetailsScreen.propTypes = {
  emarRoundTimings: PropTypes.array.isRequired,
  medication: PropTypes.object.isRequired,
  openDiscontinueMedModal: PropTypes.func.isRequired,
  resident: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  testId: PropTypes.string
}

const styles = {}

const mapStateToProps = (state, props) => {
  return {
    emarRoundTimings: state.data['emar-round-timings'],
    medication: find(Selectors.getResidentMarChart(state, props), {
      id: props.router.params.medication_id
    }),
    resident: Selectors.getResidentProfile(state, {
      id: props.router.params.id
    }),
    user: Selectors.getCurrentUserProfile(state)
  }
}

const mapDispatchToProps = (dispatch) => ({
  openDiscontinueMedModal: (medication, resident) => {
    dispatch(
      Actions.openModal({
        data: { medication, resident },
        modalId: 'discontinueMed'
      })
    )
    dispatch(Actions.addForm({ formId: 'discontinueMed' }))
  }
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DetailsScreen)
)
